import { Button } from '~/design-system/primitives'
import { LocalMall, ShoppingCartOff } from '~/icons'

export default function EmptyCart() {
  const handleRedirect = () => {
    window.location.href = '/'
  }
  return (
    <section className="pt-3">
      <div className="lg:h-screen h-96 w-full p-4 flex justify-center items-center rounded-lg bg-white">
        <div className="lg:w-6/12 h-full px-8 flex flex-col justify-center items-center rounded-lg bg-white">
          <ShoppingCartOff className="fill-gray-40 mr-1 mb-5 w-8 h-8" />
          <p className="text-xl font-bold">Seu Carrinho Está Vazio</p>
          <p className="text-base text-center">
            Você ainda não adicionou nenhum produto ao carrinho. Explore nossas categorias e encontre o que
            você precisa
          </p>
          <Button
            className="flex items-center mt-3"
            color="primary"
            hasIcon={true}
            isOutlined={true}
            onPress={handleRedirect}
          >
            <LocalMall className="fill-primary-orange mr-1" />
            Continuar Comprando
          </Button>
        </div>
      </div>
    </section>
  )
}
